import {
    Document,
    PDFViewer,
    Page as PDFPage,
    StyleSheet,
    Text as PDFText,
    View as PDFView,
    Font,
    Image as PDFImage
  } from '@react-pdf/renderer';
  
  Font.register({
    family: 'Roboto',
    fonts: [{ src: '/Roboto-Bold.ttf', fontWeight: 'medium' }]
  });
  
  const fullScreenStyles = {
    container: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      zIndex: 1000,
      backgroundColor: 'white'
    }
  };
  
  const styles = StyleSheet.create({
    page: {
      // paddingTop: '5%',
      justifyContent: 'flex-start',
      alignItems: 'center'
    },
    text: {
      fontSize: 10
    },
    textUnderlined: {
      fontSize: 10,
      textDecoration: 'underline',
      textDecorationColor: 'black',
      textDecorationThickness: 1.5,
      width: '120%'
    },
    heading: {
      fontSize: 14,
      fontWeight: 'bold',
      textAlign: 'center'
    },
    contentContainer: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      gap: 5,
      paddingBottom: '3px',
      borderBottom: '1px solid black',
      paddingTop: '115px',
      paddingRight: '30px',
      paddingLeft: '30px'
      // padding: '10px'
    },
    column: {
      width: '33%',
      display: 'flex',
      flexDirection: 'column',
      gap: 1
    },
    row: {
      display: 'flex',
      flexDirection: 'row',
      width:"100%",
      marginBottom: 5
    },
    label: {
      fontWeight: 'bold',
      fontSize: 10
    },
    value: {
      fontSize: 10,
      fontWeight: 'normal',
      width: '65%'
    }
  });
  
  const Page = ({ style, children, ...props }) => (
    <PDFPage style={{ ...styles.page, ...style }} {...props}>
      {children}
    </PDFPage>
  );
  
  const View = ({ style, children, ...props }) => (
    <PDFView style={{ ...style }} {...props}>
      {children}
    </PDFView>
  );
  
  const Text = ({ style, content, ...props }) => (
    <PDFText style={{ ...styles.text, ...style }} {...props}>
      {content}
    </PDFText>
  );
  
  export const PatientRegisterationPdf11 = ({ data }) => {
    function formatDate(dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }
  
    const ageString = data.age;
    const years = ageString.match(/\d+Y/);
  
    const formatRegTime = (time) => {
        const [hours, minutes] = time.split(':');
        const date = new Date();
        date.setHours(hours);
        date.setMinutes(minutes);
        
        // Format to 12-hour time
        const options = { hour: '2-digit', minute: '2-digit', hour12: true };
        return date.toLocaleTimeString('en-US', options);
      }
    
    return (
      <div style={fullScreenStyles.container}>
        <PDFViewer width="100%" height="100%" showToolbar>
          <Document title={`${data.name} Registration`}>
            <Page size="A4" style={styles.page}>
              <PDFImage src="/PDf Print Format.png" style={{ width: '100%', height: '100%' }} />
            </Page>
            <View style={styles.row}>
              <Text content="-      " style={{ ...styles.label, fontFamily: 'Roboto' }} />
            </View>
  
            <View style={{ ...styles.contentContainer, paddingTop: '15%' }}>
              <View style={{ ...styles.column, width: '100%' }}>
                <View style={{ ...styles.row, }}>
                  <Text content="Patient Name :        " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                  <Text
                    content={data.name}
                    style={{
                      ...styles.value,
                      borderBottom: '1px solid black',
                      textAlign: 'start',
                      paddingBottom: '2px',
                      width:"100%"
                    }}
                  />
                </View>
                <View style={{ ...styles.row, width: '100%',marginTop:"3%" }}>
                  <Text content="Age :                       " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                  <Text
                    content={years ? years[0] : 'N/A'}
                    style={{
                      ...styles.value,
                      borderBottom: '1px solid black',
                      textAlign: 'start',
                      paddingBottom: '2px'
                    }}
                  />
                  <Text content="Sex :                       " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                  <Text
                    content={data.gender || 'N/A'}
                    style={{
                      ...styles.value,
                      borderBottom: '1px solid black',
                      textAlign: 'start',
                      paddingBottom: '2px'
                    }}
                  />
                  <Text content="Date :                      " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                  <Text
                    content={`${formatDate(data.reg_date)} / ${formatRegTime(data.reg_time)}` || 'N/A'}
                    style={{
                      ...styles.value,
                      borderBottom: '1px solid black',
                      textAlign: 'start',
                      paddingBottom: '2px'
                    }}
                  />
                </View>
                <View style={{ ...styles.row, width: '100%',marginTop:"3%" }}>
                  <Text content="Address :     " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                  <Text
                    content={data.address}
                    style={{
                      ...styles.value,
                      borderBottom: '1px solid black',
                      textAlign: 'start',
                      paddingBottom: '2px',
                      width:"100%"
                    }}
                  />
                </View>
              </View>
            </View>
          </Document>
        </PDFViewer>
      </div>
    );
  };
  